'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { Record, Map as ImmutableMap } from 'immutable';
import { FORM_FIELD_TYPES } from 'MeetingsBase/constants/enums';
var defaults = {
  firstName: '',
  lastName: '',
  email: '',
  customFormFields: ImmutableMap()
};

var constructCustomFormFields = function constructCustomFormFields(prefillObj) {
  var formFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var fields = formFields.reduce(function (acc, field) {
    var prefillValue = prefillObj[field.name];

    if (!prefillValue) {
      return acc;
    }

    if (field.fieldType === FORM_FIELD_TYPES.BOOLEAN_CHECKBOX) {
      return acc.set(field.name, JSON.parse(prefillValue));
    } else if (field.fieldType === FORM_FIELD_TYPES.CHECKBOX) {
      return acc.set(field.name, prefillValue.split(';'));
    } else {
      return acc.set(field.name, prefillValue);
    }
  }, ImmutableMap());
  return fields;
};

var FormPrefills = /*#__PURE__*/function (_Record) {
  _inherits(FormPrefills, _Record);

  function FormPrefills() {
    _classCallCheck(this, FormPrefills);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormPrefills).apply(this, arguments));
  }

  _createClass(FormPrefills, null, [{
    key: "from",
    value: function from(json, formFields) {
      var firstname = json.firstname,
          lastname = json.lastname,
          email = json.email,
          rest = _objectWithoutProperties(json, ["firstname", "lastname", "email"]);

      return new FormPrefills({
        firstName: firstname,
        lastName: lastname,
        email: email,
        customFormFields: constructCustomFormFields(rest, formFields)
      });
    }
  }]);

  return FormPrefills;
}(Record(defaults));

export { FormPrefills as default };